import * as yup from "yup";

export const ProfileDescriptionInputForm = yup.object({
  description: yup.string().required().max(600).min(20)
})
